<template>
  <div class="loading-container" v-show="visible">
    <div class="loading-content">
      <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="title" v-show="title">{{title}}</div> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  components: {
  },
  props: {
    visible: Boolean,
    title: String
  },
  methods: {
    handleButton () {
    
    }
  }
};
</script>

<style scoped lang="scss">
.loading-container {
  background: rgba($color: #000000, $alpha: 0.8);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  .loading-content {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .title {
    color: #fff;
    margin-top: 40px;
  }
  .loading{
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: space-between;
  }
  .loading span{
    display: inline-block;
    width: 8px;
    height: 100%;
    border-radius: 4px;
    background: #1dde9f;
    -webkit-animation: load 1s ease infinite;
  }
  @-webkit-keyframes load{
    0%,100%{
      height: 40px;
      background: #1dde9f;
    }
    50%{
      height: 70px;
      margin: -15px 0;
      background: #1dc9ca;
    }
  }
  .loading span:nth-child(2){
    -webkit-animation-delay:0.2s;
  }
  .loading span:nth-child(3){
    -webkit-animation-delay:0.4s;
  }
  .loading span:nth-child(4){
    -webkit-animation-delay:0.6s;
  }
  .loading span:nth-child(5){
    -webkit-animation-delay:0.8s;
  }
}
</style>
